function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M191.6 64l-.1 28.3h43.2l-63.5 51.6-57.1-57.3-73.6 65.6 18.9 21.3 53.5-47.7 56.3 56.4 85.8-69.8v43.4h28.5V64h-91.9zM28.3 255.1V0H0v283.5h283.5v-28.4H28.3z"
})));